// 現在地（Geolocation）から最寄り地点を取得して切り替えるボタン。
// ヘッダーに常駐させ、誤タップを避けるためアイコン単体で配置する。

import { apiGetTide } from '../api.js';
import { getCurrentLocation } from '../lib/geolocation.js';
import { useStore } from '../state/store.js';

export function LocateButton(): JSX.Element {
  const date = useStore((s) => s.date);
  const isLoading = useStore((s) => s.isLoading);
  const setIsLoading = useStore((s) => s.setIsLoading);
  const setError = useStore((s) => s.setError);
  const setTideData = useStore((s) => s.setTideData);
  const setSelectedStation = useStore((s) => s.setSelectedStation);

  const onClick = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);
    try {
      const coords = await getCurrentLocation();
      const r = await apiGetTide(coords.lat, coords.lon, date);
      setTideData(r);
      setSelectedStation({
        id: r.station.id,
        name: r.station.name,
        name_kana: r.station.name_kana,
        prefecture: r.station.prefecture,
        latitude: r.station.latitude,
        longitude: r.station.longitude,
      });
    } catch (e) {
      setError(`現在地の取得に失敗: ${String(e)}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={() => void onClick()}
      disabled={isLoading}
      aria-label="現在地から最寄り地点を取得"
      title="現在地から最寄り地点を取得"
      className="px-2 py-1 rounded bg-slate-700 hover:bg-slate-600 text-base disabled:opacity-50 disabled:cursor-not-allowed"
    >
      📍
    </button>
  );
}
